import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import classNames from 'classnames';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import { connect} from "react-redux";
import {showSuccessSnackbar, showErrorSnackbar} from '../store/actions/snackbarActions';
import  {putData } from '../ApiCalls/DataApis';
import Tooltip from '@material-ui/core/Tooltip';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import IconButton from '@material-ui/core/IconButton';
import { Typography } from '@material-ui/core';

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#757575",
    color: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    fontSize: 12,
    border: '1px solid #fafafa',
  },
  arrow: {
    color: '#757575',
  },
}))(Tooltip);

const styles = theme => ({
  paper: {
    position: 'relative',
    width: theme.spacing(60),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0),
    borderRadius: '10px',
    [theme.breakpoints.down('xs')]:{
      width: theme.spacing(43),
    }
  },
  button: {
    backgroundColor:'transparent',
    borderRadius:'24px',
    border:'1px solid #4f86ce',
    display:'inline-block',
    cursor:'pointer',
    color:'#4f87cc',
    fontFamily:'Trebuchet MS',
    fontSize:'10px',
    // font-weight:bold;
    // height: '34px',
    padding:'3px 10px',
    textDecoration:'none',
    textShadow:'0px 0px 0px #9eb9ff',
    outline: 'none',
    '&:hover': {
      backgroundColor:'transparent',
    },
    '&:active': {
      position:'relative',
      top:'1px',
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  buttonSuccess: {
    backgroundColor: green[500],
    color: '#fafafa',
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  nodeRedCredentialsBtn:{
    color: '#4f87cc',
    outline: 'none',
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  dialog: { 
    borderRadius: 10,
    width: theme.spacing(60),
    [theme.breakpoints.down('xs')]:{
      width: theme.spacing(43),
    } } ,
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class EditDeviceCredentialsModal extends React.Component {
  constructor(props){
    super(props);
    this.state ={
      open: false,
      loading: false,
      success: false,
      node_red_name: '',
      node_red_password: '',
    }
    this.handleOpen = this.handleOpen.bind(this);
   

  }

  timer = undefined;

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  handleOpen = () => {
    this.setState({ 
      open: true,
      loading: false,
      success: false, });
  };

  handleClose = () => {
    this.setState({ 
      open: false,
      loading: false,
      success: false,});
  };

  submitButtonClick = () => {
    const { loading } = this.state;
    if (!loading) {
      this.setState(
        {
          success: false,
          loading: true,
        },
        () => {
        putData('https://api.iotflows.com/v1/devices/' + this.props.device_uuid + '/nodered/set_credentials', 
        {'nodered_username': this.state.node_red_name,
          'nodered_password': this.state.node_red_password})
          .then(async response => {
            if(response.ok){
              this.props.showSuccessSnackbar("Node-Red Credentials has been successfully modified!");
              this.setState({
                loading: false,
                success: true,
                open:false,
              });
            }
            else{
              try{
                const data = await response.json();
                this.props.showErrorSnackbar(data.message);
                this.setState({
                  loading: false,
                  success: false,
                  open:false,
                });
              }catch (e){
                this.props.showErrorSnackbar('Something went wrong');
              }
            }
          })
          this.setState({
            loading: false,
            success: false,
          });
        }
      )
    }
  };

  handleNodeRedNameChange = (event) => {
    this.setState({node_red_name: event.target.value});
  }

  handleNodeRedPasswordChange = (event) => {
    this.setState({node_red_password: event.target.value});
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      device_disabled: nextProps.device_disabled,
    }); 
  };


  render() {
    const { classes } = this.props;
    const { open, loading, success, node_red_name, node_red_password, device_disabled } = this.state;

    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    });
    

    return (
      <Grid>
        {/* <IconButton style={{padding: '0px',paddingTop: '5px', paddingLeft: '10px'}} onClick={this.handleOpen} aria-label="EditDeviceCredentialsModal">
          <VpnKeyOutlinedIcon  />
        </IconButton> */}

          <LightTooltip className={classes.hoverText} title={'Change Node-RED login credentials'} placement="top-end" arrow>
            {/* <Button className={classes.button} onClick={this.handleOpen} disabled={device_disabled} variant="contained" >
              Credentials         
            </Button> */}
            <IconButton className={classes.nodeRedCredentialsBtn} onClick={this.handleOpen}>
              <SettingsOutlinedIcon  style={{fontSize:"24px"}} />
            </IconButton>
          </LightTooltip> 
          <Dialog
              open={open}
              onClose={this.handleClose}
              TransitionComponent={Transition}
              keepMounted
              classes = {{paper: classes.dialog}}
            >
              <Paper className={classes.paper} >
                <DialogTitle style={{paddingBottom: '0px'}} >{"Configure Device Node-RED Credentials"}</DialogTitle>
                <DialogContent dividers style={{paddingBottom: '20px', paddingTop: '0px'}}>
                  <TextField
                  autoFocus
                  margin="normal"
                  label="Node-RED username"
                  type="text"
                  onChange={this.handleNodeRedNameChange}
                  fullWidth
                  />

                  <TextField
                  autoFocus
                  margin="normal"
                  label="Node-RED Password"
                  type="password"
                  onChange={this.handleNodeRedPasswordChange}
                  fullWidth
                  />

                  <Typography>
                    Default Node-RED credentials
                  </Typography>
                  <Typography>
                    <span> username: </span> <span style={{fontWeight: 700}}>admin</span>
                  </Typography>
                  <Typography>
                    <span> password: </span> <span style={{fontWeight: 700}}>password</span>
                  </Typography>

                </DialogContent>
                <DialogActions style={{justifyContent:'flex-end'}}>
                  <Button onClick={this.handleClose} >
                    Close
                  </Button>
                  <Button  color="primary" type='submit' className={buttonClassname} disabled={loading} onClick={this.submitButtonClick}>
                    Submit { loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </Button>
                </DialogActions>
              </Paper>
         
        </Dialog>
        
      </Grid>
    );
  }
}

EditDeviceCredentialsModal.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapDispatchToProps = dispatch => ({
  showSuccessSnackbar: message => dispatch(showSuccessSnackbar(message)),
  showErrorSnackbar: message => dispatch(showErrorSnackbar(message)),

})
const mapStateToProps = state => state

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(EditDeviceCredentialsModal));
